
export default [
  {
    name: "client",
    title: 'Client',
    width: "300px",
    sortField: "client.id",
    formatter(value) {
      if (value) {
        return value.name;
      } else {
        return 'N/A';
      }
    }
  },
  {
    name: "description",
    title: 'Claim',
    sortField: "fiscalYear",
    width: "500px"
  },
]